import { useState, useEffect } from 'react'
import { MOBILE_VIEW_BREAKDOWN } from './useMediaQuery'

const useTransform = (
  direction: 'left' | 'center' = 'left',
  startWidth = 1200,
) => {
  const query = `(${MOBILE_VIEW_BREAKDOWN} < width < ${startWidth}px)`
  const [matches, setMatches] = useState(() => 
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  )
  const [width, setWidth] = useState(() => 
    typeof window !== 'undefined' ? window.innerWidth : startWidth
  )

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const mediaQueryList = window.matchMedia(query)

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQueryList.addEventListener('change', listener)

    return () => {
      mediaQueryList.removeEventListener('change', listener)
    }
  }, [query])

  useEffect(() => {
    if (typeof window === 'undefined' || !matches) {
      return
    }

    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [matches])

  if (typeof window === 'undefined') {
    return {}
  }

  return matches
    ? {
        transform: `scale(${1 - (startWidth - width) / 2500})`,
        transformOrigin: `top ${direction}`,
      }
    : {}
}

export default useTransform
